import { configureStore } from '@reduxjs/toolkit';
import { safepassApi } from './api';
import { onSessionEnded } from '@/lib/session';

export const store = configureStore({
  reducer: {
    [safepassApi.reducerPath]: safepassApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(safepassApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

/*
  Throw away every cached query when a session ends.

  Without this the next person to sign in on the same machine — a different
  officer at the same gate, which is the normal case at shift change — sees the
  previous one's children, board and audit log for as long as the cache lives.
  Flipping `isAuthenticated` redirects them; it does not forget anything.
*/
onSessionEnded(() => {
  store.dispatch(safepassApi.util.resetApiState());
});
